import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { staticTask, timedTask } from './create';
const render = timedTask({
    name: 'Initial render',
    description: `This task records how long ReactDOM.render() takes with your component`,
    run: async ({ getElement, container }) => {
        ReactDOM.render(getElement(), container);
    },
});
const hydrate = timedTask({
    name: 'Hydrate',
    description: `
      This task records how long a ReactDOMServer.hydrate() call
      takes. If you are server side rendering a React component then html is
      sent down to the browser. Hydration is the process of React reading through
      the HTML and building up it's internal virtual model. After hydration React
      is able to take over the HTML as if it had done the original render on the client.
  `,
    run: async ({ getElement, controls, container }) => {
        const html = ReactDOMServer.renderToString(getElement());
        container.innerHTML = html;
        await controls.time(async function mount() {
            ReactDOM.hydrate(getElement(), container);
        });
    },
});
const reRender = timedTask({
    name: 'Re render',
    description: `
      This task records how long it takes to re-render the component with no prop changes.
      Note: You can improve this score quickly by using React.memo near the top of your
      component tree.
  `,
    run: async ({ getElement, controls, container }) => {
        ReactDOM.render(getElement(), container);
        await controls.time(async function mount() {
            ReactDOM.render(getElement(), container);
        });
    },
});
const domElementCount = staticTask({
    name: 'DOM element count',
    description: `
    The more DOM element your component creates, the more work the browser needs to do
  `,
    run: async ({ getElement, container }) => {
        ReactDOM.render(getElement(), container);
        const allChildren = Array.from(container.querySelectorAll('*'));
        return String(allChildren.length);
    },
});
const group = {
    groupId: 'Client',
    name: 'Client 👩‍💻',
    tasks: [render, reRender, hydrate, domElementCount],
};
export default group;
